export const STYLE_MAP = {
  default: {
    backgroundColor: '#FFFFFF',
    middleTitleColor: '#1E2E37',
    middleSubTitleColor: '#616C73'
  },
  diablo: {
    backgroundColor: '#101315',
    middleTitleColor: '#CFCFD0',
    middleSubTitleColor: '#8E969B'
  },
  colmo: {
    backgroundColor: '#151617',
    middleTitleColor: 'rgba(255,255,255,0.80)',
    middleSubTitleColor: 'rgba(255,255,255,0.40)'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-minibar/style.js